/**
 * FreeGiveawayPage — 100% free concierge-audit landing at `/free`.
 *
 * Composition mirrors HomeV2Page: same left-column pitch, same social
 * proof + FAQ + CTA sections. The only swap is the right-side hero card
 * (now a 2-step lead form for the free giveaway). SEO-noindex so it does
 * not compete with `/` in organic search.
 */
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { useAuth } from '../lib/auth-context';

import { FreeGiveawayHero } from '../components/landing/FreeGiveawayHero';
import { MarqueeStrip } from '../components/landing/MarqueeStrip';
import { PromiseSection } from '../components/landing/PromiseSection';
import { FeatureShowcase } from '../components/landing/FeatureShowcase';
import { MidScrollCTA } from '../components/landing/MidScrollCTA';
import { PersonasSection } from '../components/landing/PersonasSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTA } from '../components/landing/FinalCTA';
import SeoHead from '../components/seo/SeoHead';

export default function FreeGiveawayPage() {
  const navigate = useNavigate();
  const { user } = useAuth() || {};
  const onPrimaryCta = useMemo(
    () => () => {
      if (user) navigate('/dashboard');
      else navigate('/signup');
    },
    [navigate, user],
  );

  return (
    <AppShell>
      <SeoHead
        title={'Blayzrr — Free LinkedIn Profile Makeover, emailed to you'}
        description={'Paste your LinkedIn URL, pick a goal, and receive a fully audited and rewritten LinkedIn profile in your inbox — 100% free.'}
        path={'/free'}
        robots="noindex, nofollow"
      />
      <FreeGiveawayHero />
      <PersonasSection />
      <MarqueeStrip />
      <FeatureShowcase />
      <PromiseSection />
      <MidScrollCTA variant="trial" onPrimaryCta={onPrimaryCta} />
      <FAQSection />
      <FinalCTA onPrimaryCta={onPrimaryCta} />
    </AppShell>
  );
}
